import { HttpRepository } from '@/modules/shared/shared/domain/repositories/http.repository';
import { ContactPrivilegeInterface } from '@/modules/contacts/shared/domain/contact.privilege.interface';
import { ContactView } from '@/modules/contacts/shared/domain/contact.view';
import { Role } from '@/modules/users/domain/role.interface';

class RolesRepository extends HttpRepository {
    private static readonly RESOURCE = 'roles';

    async getPrivileges(): Promise<{ data: ContactPrivilegeInterface[] }> {
        return this.get(
            this.createUri([`${RolesRepository.RESOURCE}/resources`]),
            this.createAuthorizationHeader(),
        );
    }

    async getView(customerId): Promise<ContactView> {
        return (
            await this.get(
                this.createUri([`views/customers/${customerId}/contacts/generate`]),
                this.createAuthorizationHeader(),
            )
        ).data.values;
    }

    async createRol(rol: {}) {
        return this.post(
            this.createUri([`${RolesRepository.RESOURCE}`]),
            rol,
            this.createAuthorizationHeader(),
        );
    }

    async updateRol(rol: { id: number }) {
        return this.patch(
            this.createUri([`${RolesRepository.RESOURCE}/${rol.id}`]),
            rol,
            this.createAuthorizationHeader(),
        );
    }
}

export const rolesRepository = new RolesRepository();
